{
  "mmbRefundForm": {
    "recLocGenericError": "Something went wrong while searching for your booking. Please try again.",
    "tryRefundFormError": "This booking can’t be cancelled using this tool. Please use the form below to request a refund."
  },
  "productSelection": {
    "tierPrice": {
      "nextProduct": {
        "ABCBAG": "Next bag"
      },
      "addProduct": {
        "ABCBAG": "Add for"
      }
    }
  }
}
